import React, {useState} from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {observer} from 'mobx-react-lite';

import OrderDetails from '../../../components/checkout/OrderDetails';
import InputModal from '../../../components/checkout/OrderDetails/InputModal';
import OrderNotes from '../../../components/checkout/OrderDetails/OrderNotes';
import PickupDeliverComponent from '../../../components/pickupDeliver/PickupDeliverComponent';
import SafeAreaPadding from '../../../components/SafeAreaPadding';
import Button from '../../../components/themed/Button';
import ContentView from '../../../components/ui-controls/layout/ContentView';
import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import {AppRoute} from '../../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {useStores} from '../../../stores/use-stores';
import OrderTotals from '../components/OrderTotals';
import {handleContinue, useRedirectEmptyCart} from '../util/validation';

const CheckoutScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.CART_ORDER_CHECKOUT>) => {
    // redirect empty cart
    useRedirectEmptyCart(navigation);

    const {cartStore, paymentStore, userStore} = useStores();
    const {isWebDesktopScreen} = useWebScreenDimensions();

    const [isOrderNotesModalVisible, setIsOrderNotesModalVisible] =
      useState(false);

    const saveOrderNote = (value: any) => {
      cartStore.setOrderNotes(value);
      cartStore.updateOrderNotes();
      setIsOrderNotesModalVisible(false);
    };

    return (
      <ContentView testID="checkout-screen">
        <KeyboardAwareScrollView
          style={{backgroundColor: 'white'}}
          keyboardShouldPersistTaps="always"
          showsVerticalScrollIndicator={isWebDesktopScreen}
          showsHorizontalScrollIndicator={isWebDesktopScreen}>
          <PickupDeliverComponent />
          <OrderDetails />
          <InputModal
            element={({onPress}) => (
              <OrderNotes
                onPress={onPress}
                notes={cartStore.orderNotes || 'Add note to store'}
                testID="checkout-screen-order-notes"
              />
            )}
            isVisible={isOrderNotesModalVisible}
            title="Add note to store"
            saveAction={saveOrderNote}
            saveText="UPDATE"
            closeAction={() => setIsOrderNotesModalVisible(false)}
            openAction={() => setIsOrderNotesModalVisible(true)}
            initialValue={cartStore.orderNotes}
            placeholder="Add note to store"
          />
          <View style={{flexGrow: 1}} />
          <OrderTotals>
            <Button
              onPress={handleContinue({
                paymentStore,
                cartStore,
                userStore,
                callback: () => {
                  navigation.navigate(AppRoute.CART_ORDER_CHECKOUT_REVIEW);
                },
              })}
              title="REVIEW ORDER"
            />
          </OrderTotals>
        </KeyboardAwareScrollView>
        <SafeAreaPadding bottom />
      </ContentView>
    );
  },
);

export default CheckoutScreen;